import styled, { css } from "styled-components";
import { Link } from "react-router-dom";

import { HEADER_HEIGHT, HEADER_HEIGHT_MOBILE } from "../../lib/constants";

const MEDIA_MOBILE_JOIN_BTN = "(max-width: 392px)";

export const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;

  background-color: #ffffff99;
  backdrop-filter: blur(63.17px);
  box-shadow: ${({ $isScrolled }) =>
    $isScrolled ? "0 1px #1d1d1d1a" : "none"};
  transition: box-shadow 0.2s ease;
`;

export const HeaderContainer = styled.div`
  margin: 0 auto;
  padding: 0 48px;
  height: ${HEADER_HEIGHT}px;
  max-width: 1440px;
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 40px;
  text-align: center;
  justify-content: space-between;
  box-sizing: border-box;

  @media ${({ theme }) => theme.media.mobileForHeader} {
    max-width: 100%;
    height: ${HEADER_HEIGHT_MOBILE}px;
    padding: 0 0.8rem;
    margin: 0;
  }
`;

export const LogoLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 100%;

  ${({ $isDisabled }) =>
    !!$isDisabled &&
    css`
      pointer-events: none;
      cursor: default;
    `}
`;

export const Logo = styled.img`
  object-fit: contain;
  width: 144px;
  height: 38px;
  align-self: stretch;
  z-index: 0;
  flex-shrink: 0;
  margin: auto 0;

  @media ${MEDIA_MOBILE_JOIN_BTN} {
    height: auto;
    max-height: 38px;
    width: 100%;
    max-width: 144px;
  }
`;

export const Navigation = styled.nav`
  position: absolute;
  z-index: 0;
  display: flex;
  min-width: 240px;
  min-height: 42px;
  align-items: center;
  gap: 4px;
  color: #1d1d1dd9;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  transform: translateX(-50%);

  height: 42px;
  left: 50%;
  bottom: 16px;

  @media ${({ theme }) => theme.media.mobileForHeader} {
    display: none;
  }
`;

export const MobileNavigationContainer = styled.div`
  position: fixed;
  width: 100%;
  padding: 0 16px;
  padding-top: 75px;
  z-index: 40;
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.3s;
  transform: translate(${({ $isOpened }) => ($isOpened ? "0" : "100%")}, 0)
    rotate(0) skew(0) skewY(0) scaleX(1) scaleY(1);

  @media ${({ theme }) => theme.media.nonMobileForHeader} {
    display: none;
  }
`;

export const MobileNavItems = styled.div`
  margin-bottom: 40px;
  width: 100%;
`;

export const MobileNavigation = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: #ffffff;
  border: 1px solid rgba(29, 29, 29, 0.1);
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  padding: 20px 32px 32px 32px;
  max-height: calc(100vh - 75px - 10px);
  overflow: hidden auto;
`;

export const NavLink = styled.a`
  align-self: stretch;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
  }

  @media ${({ theme }) => theme.media.mobileForHeader} {
    height: auto;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: rgba(29, 29, 29, 0.85);
    text-align: left;
    padding: 12px 0;
    border-bottom: 1px solid rgba(29, 29, 29, 0.1);
    border-radius: 0;
    justify-content: flex-start;

    &:hover {
      background-color: unset;
    }
  }

  ${({ $isContactUs }) =>
    $isContactUs
      ? css`
          @media ${({ theme }) => theme.media.nonMobile} {
            display: none;
          }
        `
      : ""}
`;

export const NavMenuItemWrapper = styled.div``;

export const NavMenuItem = styled.div`
  position: relative;
  align-self: stretch;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
  }

  > span {
    position: relative;
    padding-right: 24px;

    &::after {
      content: "";
      background-image: url(/images/icons/caret-down.svg);
      background-size: 16px;
      background-repeat: no-repeat;
      position: absolute;
      top: calc((100% - 16px) / 2);
      right: 0;
      width: 16px;
      height: 16px;
      transition: transform 0.3s ease;

      ${({ $isOpen }) =>
        $isOpen &&
        css`
          transform: rotate(180deg);
        `}
    }

    @media ${({ theme }) => theme.media.mobileForHeader} {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
    }
  }

  @media ${({ theme }) => theme.media.mobileForHeader} {
    height: auto;
    font-family: ${({ theme }) => theme.fonts.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: rgba(29, 29, 29, 0.85);
    text-align: left;
    padding: 12px 0;
    border-bottom: 1px solid rgba(29, 29, 29, 0.1);
    border-radius: 0;
    align-items: flex-start;
    flex-direction: column;

    &:hover {
      background-color: unset;
    }
  }
`;

export const ActionsContainer = styled.div`
  align-self: stretch;
  z-index: 0;
  display: flex;
  // min-width: 240px;
  align-items: center;
  gap: 8px;
  margin: auto 0;

  @media ${({ theme }) => theme.media.mobileForHeader} {
    // min-width: unset;
  }
`;

export const ContactLink = styled.a`
  align-self: stretch;
  color: #1d1d1dd9;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  margin: auto 0;
  padding: 8px;
  border-radius: 12px;
  text-decoration: none;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f3f4f6;
  }

  @media ${({ theme }) => theme.media.mobileForHeader} {
    display: none;
  }
`;
